import React from 'react';
import { connect } from 'react-redux';

import store from '../store';

import {
    metaStoreUpdateDupes,
    metaStoreIdentityField,
} from '../modules/Meta/actions';

import SobjectFieldList from './SobjectFieldList';

const { dispatch } = store;

class UpdateDuplicates extends React.Component {
    renderForm() {
        const { update_dupes, sobjectName, feeds, idx } = this.props;

        if (sobjectName == '' || !feeds.hasOwnProperty(sobjectName) || !update_dupes.hasOwnProperty(sobjectName)) {
            return <div className="spinner is-active" />;
        }

        const { enabled, identity_field } = update_dupes[sobjectName];

        if (!enabled) {
            return null;
        }

        return (
            <div id="viagf_identity_field">
                <table className="form-table gforms_form_settings">
                    <tbody>
                        <tr>
                            <th> <label> Match Field </label> </th>
                            <td><SobjectFieldList idx={idx} selected={identity_field} onChange={e => {
                                dispatch(metaStoreIdentityField(sobjectName, e.target.value));
                            }}/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        let enabled = false;

        const { sobjectName, update_dupes } = this.props;

        if (update_dupes.hasOwnProperty(sobjectName)) {
            enabled = update_dupes[sobjectName].enabled;
        }

        return (
            <React.Fragment>
                <input type="checkbox" id="update_dupes" checked={enabled} onChange={e => {
                    dispatch(metaStoreUpdateDupes(sobjectName, e.target.checked));
                }} />
                <label htmlFor="update_dupes"> Update duplicates</label>
                {this.renderForm()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        update_dupes: store.metaState.get('update_dupes').toJS(),
        sobjectName: store.metaState.get('sobject').get('name'),
        feeds: store.feedsState.get('feeds').toJS(),
    }
};

export default connect(mapStateToProps)(UpdateDuplicates);
